import { useOnlineStatus } from '@/shared/hooks/useOnlineStatus';
import { WifiOff } from 'lucide-react';

/**
 * Offline Banner Component
 *
 * Displays a persistent banner at the top of the screen when the user goes offline.
 * Automatically disappears when connection is restored.
 *
 * Features:
 * - Animated slide-in/out
 * - Fixed positioning at top of viewport
 * - High z-index to ensure visibility
 * - Distinctive warning colors
 */
export default function OfflineBanner() {
  const isOnline = useOnlineStatus();

  if (isOnline) {
    return null;
  }

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[9999] animate-in slide-in-from-top duration-300"
      role="alert"
      aria-live="assertive"
    >
      <div className="bg-amber-500 text-white px-4 py-3 shadow-lg">
        <div className="flex items-center justify-center gap-2 max-w-7xl mx-auto">
          <WifiOff className="w-5 h-5 flex-shrink-0" />
          <p className="text-sm font-medium">
            You are currently offline. Some features may be unavailable.
          </p>
        </div>
      </div>
    </div>
  );
}
